<template>
  <table>
    <tr>
      <td :style="mainStyle">
        <br>
        <b v-if="name" :style="nameStyle">{{name}}, </b>{{jobTitle}}<br>
        <a v-if="email" :href="`mailto:${email}`" :style="linkStyle">{{email}}</a>
        <template v-if="extension || mobile"> <Separator :color="colors.black" character="•"/> </template>
        <template v-if="extension">0203 745 5{{ extension }}</template><template v-if="extension && mobile"> <Separator :color="colors.black" character="•"/> </template><template v-if="mobile">{{ mobile }}</template>
        <template v-if="extraInfo"><br><br><b :style="extraInfoStyle">{{ extraInfo }}</b></template>
        <template v-if="email || extension || mobile"><br><br></template>

        <div>
          <table>
            <tr>
              <td valign="middle" :style="footerLogoCellStyle">
                <email-safe-image url="https://fivium.co.uk/email-signatures/fivium-white-outlook.png" :width="140" :height="35" :email-app="emailApp" alt="Fivium" :padding-right="20" :padding-left="20"/>
              </td>
              <td valign="middle" :style="footerTextCellStyle">
                <span :style="nowrap">15 Adam Street</span>, London, <span :style="nowrap">WC2N 6AH</span>
                <Separator :color="colors.black" character="•"/>
                <a href="https://www.fivium.co.uk" target="_blank" :style="footerLinkStyle">fivium.co.uk</a>
                <Separator :color="colors.black" character="•"/>
                <span :style="nowrap">0800 3689 345</span>
                <br>
                Follow us on <a href="https://linkedin.com/company/fivium/" target="_blank" :style="footerLinkStyle">LinkedIn</a>
                <Separator :color="colors.black" character="•"/>
                Twitter <a href="https://twitter.com/FiviumUK" target="_blank" :style="footerLinkStyle">@FiviumUK</a>
                <Separator :color="colors.black" character="•"/>
                Facebook <a href="https://facebook.com/fivium" target="_blank" :style="footerLinkStyle">@Fivium</a>
              </td>
            </tr>
            <tr v-if="hasCta">
              <td colspan="2" :style="footerCTAStyle">
                <span :style="footerCTATextStyle" v-html="ctaText"></span>
                <a :href="ctaLinkUrl" :style="footerCTALinkStyle" target="_blank">{{ ctaLinkText }}</a>
              </td>
            </tr>
            <tr>
              <td colspan="2" :style="footerAccreditationsStyle">
                <email-safe-image url="https://fivium.co.uk/email-signatures/iip-ttc.png" :width="254" :height="36" :email-app="emailApp" alt="Investors in People Gold. Proud to support Time to Change." :padding-right="0" :padding-left="0" float="right"/>
                <span style="color: white">.</span>
              </td>
            </tr>
          </table>
        </div>

      </td>
    </tr>
  </table>
</template>

<script>
import EmailSafeImage from "@/components/EmailSafeImage";
import Separator from "@/components/Separator";

export default {
  name: "SignatureTemplateFivium",
  components: { EmailSafeImage, Separator },
  props: [
    'name',
    'jobTitle',
    'email',
    'extension',
    'mobile',
    'extraInfo',
    'emailApp',
    'ctaText',
    'ctaLinkUrl',
    'ctaLinkText',
    'showCta'
  ],
  data() {
    const colors = {
      lightBlue: '#f5f8fa',
      midBlue: '#e3e8ec',
      darkBlue: '#011C35',
      white: '#ffffff',
      black: '#666',
      linkBlue: '#15c'
    };

    const fontFamily = 'Arial, Helvetica, sans-serif';
    const fontSize = '13.333px';

    return {
      colors: colors,
      fontFamily: fontFamily,
      fontSize: fontSize,
      nameStyle: {
        color: colors.black,
        fontWeight: 'bold',
        fontSize: fontSize,
        fontFamily: fontFamily
      },
      extraInfoStyle: {
        color: colors.black,
        fontWeight: 'bold',
        fontSize: fontSize,
        fontFamily: fontFamily
      },
      linkStyle: { color: colors.linkBlue },
      mainStyle: {
        color: colors.black,
        fontSize: fontSize,
        fontFamily: fontFamily
      },
      footerLinkStyle: {
        color: colors.linkBlue,
        textDecoration: 'underline',
        whiteSpace: 'nowrap'
      },
      footerCTAStyle: {
        borderRadius: '0 0 5px 5px',
        backgroundColor: colors.midBlue,
        color: colors.black,
        padding: '15px 20px',
        textAlign: 'center'
      },
      footerCTATextStyle: {
        fontFamily: fontFamily,
        fontSize: fontSize,
        color: colors.black,
        fontWeight: 'bold'
      },
      footerCTALinkStyle: {
        textDecoration: 'underline',
        color: colors.linkBlue,
        fontWeight: 'bold',
        fontFamily: fontFamily,
        fontSize: fontSize
      },
      footerAccreditationsStyle: {
        paddingTop: '10px'
      },
      nowrap: {
        whiteSpace: 'nowrap'
      }
    }
  },
  computed: {
    footerLogoCellStyle() {
      return {
        background: this.colors.darkBlue,
        borderRadius: `5px 0 0 ${this.hasCta ? 0 : 5}px`}
    },
    footerTextCellStyle() {
      return {
        padding: '20px',
        borderRadius: '0 5px 5px 0',
        background: this.colors.lightBlue,
        color: this.colors.black,
        fontSize: this.fontSize,
        fontFamily: this.fontFamily
      }
    },
    hasCta() {
      return (this.ctaText || (this.ctaLinkText && this.ctaLinkUrl)) && this.showCta
    }
  }
}
</script>

<style scoped>

</style>
